<template>
  <div class="fullPage" ref="fullPage">
    <header-nav color="transparent" class="header1" :style="{ opacity: display }" :transparent="transparent"></header-nav>
    <div class="home" ref="fullPageContainer" @mousewheel="mouseWheelHandle" @DOMMouseScroll="mouseWheelHandle">
      <div class="home-top" style="height: 100vh;">
      </div>
      <div ref="2" class="home-data" style="height: 100vh;">
        <div style="width:100%;margin-top: 113px;">
          <div class="home-data_header">
            <p class="p1">成为千万货车司机的数字化服务平台</p>
            <p class="p2">中网慧通·用数字化改造物流最后一公里</p>
          </div>
          <div class="home-data_bottom">
            <div class="item">
              <div>
                <img class="img1" src="@/assets/home/icon1.png" alt="" />
              </div>
              <p class="description">每月数以万计的司机增长</p>
              <p>司机<span class="num">{{ num1 }}万</span>+</p>
            </div>
            <div class="item">
              <div>
                <img class="img2" src="@/assets/home/icon2.png" alt="" />
              </div>
              <p class="description">遍布内蒙、宁夏、陕西、山西、新疆</p>
              <p>货场<span class="num">{{ num2 }}</span>+</p>
            </div>
            <div class="item">
              <div>
                <img class="img3" src="@/assets/home/icon3.png" alt="" />
              </div>
              <p class="description">月开具提煤单、排队车次</p>
              <p>车次<span class="num">{{ num3 }}万</span>+</p>
            </div>
            <div class="item">
              <div>
                <img class="img4" src="@/assets/home/icon4.png" alt="" />
              </div>
              <p class="description">服务贸易商、物流商、信息部</p>
              <p>客商<span class="num">{{ num4 }}</span>+</p>
            </div>
          </div>
          <div class="statistics">
            <p>数据统计截止至2023年2月28日</p>
            <p>*数据来源：技术中心</p>
          </div>
        </div>

      </div>
      <div ref="3" class="home-huochang" style="height: 100vh;">
        <div class="home-huochang_left">
          <h1>{{ swiperInfo.text1 }}</h1>
          <p class="p1">{{ swiperInfo.text2 }}</p>
          <div style="width:602px">
            <el-carousel height="371px" indicator-position="none" :autoplay="false" ref="carousel" arrow="never">
              <el-carousel-item v-for="item in imgList" :key="item.id">
                <img class="img" :src="item.img" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="home-huochang_right">
          <div class="p2"> <span class="p1">0{{ swiperInfo.id }}</span>/04</div>
          <div class="right_btn">
            <img src="@/assets/home/left.png" @click="prevSiwper()" alt="">
            <img src="@/assets/home/right.png" alt="" @click="nextSiwper()">
          </div>
          <div>
            <img class="nextImg" :src="nextImg" alt="">
          </div>
        </div>
      </div>
      <div ref="4" class="home-pt" style="height: 100vh;">

        <!-- <div class="home-pt_content">
          <div>
            <h1> 多端管理一体化后台管理平台 </h1>
            <p class="p1">Multi-end management integrated background management platform</p>
            <el-input placeholder="ph.zhhcd.com" suffix-icon="el-icon-search" class="input"></el-input>
            <p class="p2">前台数据可视化 便捷知晓各类数据 </p>
            <p class="p2">智慧防疫系统 司机上传信息全部登记 支持一键导出防疫申报列表 </p>
            <p class="p2">远程排队系统 按货品煤种排队 放行推送司机 车牌识别无需下车 </p>
            <p class="p2"> 订单管理 实时掌握交易详情</p>
            <p class="p2">可视化总台 已运销车次可视化 大数据分析</p>
          </div>
        </div> -->
      </div>
      <div ref="5" class="home-shouji" style="height: 100vh;">
        <div class="content">
          <div class="contentImg">
            <img src="@/assets/home/banner5.png" alt="">
          </div>
          <!-- <div class="right">
            <h1>手机端远程排队 减少拥堵</h1>
            <p class="p1">Mobile remote queuing to reduce congestion</p>
            <p class="p2">按货品煤种排队 长协中标VIP通道 </p>
            <p class="p2">放行推送司机 LED屏同步公示 </p>
            <p class="p2">预装在途可视化 场内容量可视化</p>
          </div> -->
        </div>
      </div>
      <div class="home-fw" style="height: 100vh;">

        <div class="content">
          <div>
            <div class="item"><img src="@/assets/home/fy1.png" alt=""></div>
            <p class="p1">全时客户服务</p>
            <p class="p2">7*24小时客服 贴心解答问题</p>
          </div>
          <div>
            <div class="item"><img src="@/assets/home/fy2.png" alt=""></div>
            <p class="p1">定时直播</p>
            <p class="p2">直播为司机解答问题 定期组织活动发放福利</p>
          </div>
          <div>
            <div class="item"><img src="@/assets/home/fw3.png" alt=""></div>
            <p class="p1">专业运维团队</p>
            <p class="p2">保证煤矿设备运行正常 四小时之内到达现场解决</p>
          </div>
          <div>
            <div class="item"><img src="@/assets/home/fw4.png" alt=""></div>
            <p class="p1">车后服务</p>
            <p class="p2">合理规划服务区司机之家 解决农牧民就业</p>
          </div>
        </div>
      </div>
      <div class="home-hb" style="height: 100vh;">
        <div class="content">
          <h1>合作伙伴</h1>
          <div class="map">
            <div class="item" v-for="(i, index) in 16" :key="index">
              <img :src="require(`@/assets/home/logo/icon${i}.png`)" alt="">
            </div>
          </div>
        </div>
      </div>
      <footer-nav id="footers"></footer-nav>
    </div>
  </div>
</template>

<script >

import headerNav from '@/components/headerNav.vue';
import footerNav from '@/components/footerNav.vue';
export default {
  components: { headerNav, footerNav },
  data() {
    return {
      screenHeight: document.documentElement.scrollHeight || document.body.scrollHeight,
      fullHeight: document.documentElement.clientHeight,
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      display: 1,
      imgList: [
        { id: 1, img: require('@/assets/siwper/banner1.png'), text1: '智慧货场', text2: '定制规则放行控制 远程预约顺序入场' },
        { id: 2, img: require('@/assets/siwper/banner2.jpg'), text1: '智慧物流', text2: '数据自动推送 抬杆秒结 多平台智能计算 选择在我' },
        { id: 3, img: require('@/assets/siwper/banner3.jpg'), text1: '交易平台', text2: '营销活动通知 用户粘连度提升' },
        { id: 4, img: require('@/assets/siwper/banner4.jpg'), text1: '车后市场', text2: '支持商圈运营 为服务区引流 品牌多样化管理' },
      ],
      swiperIndex: 0,
      swiperInfo: {},
      nextImg: null,
      transparent: 'transparent'
    };
  },
  watch: {
    'fullpage.current'(newval, oldval) {
      console.log(newval);
      if (newval == 2) {
        this.countUp()
      } else {
        clearInterval(this.timer)
        clearInterval(this.timer2)
        clearInterval(this.timer4)
        clearInterval(this.timer3)
        this.num1 = 0
        this.num2 = 0
        this.num3 = 0
        this.num4 = 0
      }
      if (newval != 1) {
        this.display = '0'
        this.transparent = ''
      } else {
        this.display = '1'
        this.transparent = 'transparent'
      }
    },
    fullHeight(val) {
      this.directToMove(this.fullpage.current)
      this.screenHeight = val
    },
    swiperIndex(val) {
      console.log(val);
      if (val == 3) {
        this.nextImg = this.imgList[0].img
      }
      else {
        this.nextImg = this.imgList[this.swiperIndex + 1].img
      }
    }
  },
  methods: {
    next() { // 往下切换
      let len = 8; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1;// 页面+1
        this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {    //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度 
      let scrollPage = this.$refs["fullPageContainer"];  // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      if (index == 8) {
        let footerheight = document.getElementById('footers').getBoundingClientRect().height;
        console.log(footerheight);
        scrollHeight = -(index - 1) * height + (height - footerheight) + "px"
      } else {
        scrollHeight = -(index - 1) * height + "px";
      }
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    },

    // 数字递增
    countUp() {
      this.timer = setInterval(() => {
        if (this.num1 === 100) {
          clearInterval(this.timer)
        } else {
          this.num1++
        }
      }, 16.6)
      this.timer2 = setInterval(() => {
        if (this.num2 === 500) {
          clearInterval(this.timer2)
        } else {
          this.num2 += 5
        }
      }, 16.6)
      this.timer3 = setInterval(() => {
        if (this.num3 === 200) {
          clearInterval(this.timer3)
        } else {
          this.num3 += 2
        }
      }, 16.6)
      this.timer4 = setInterval(() => {
        if (this.num4 === 5000) {
          clearInterval(this.timer4)
        } else {
          this.num4 += 50
        }
      }, 16.6)
    },
    prevSiwper() {
      if (this.swiperIndex == 0) {
        this.swiperIndex = 3
      } else {
        this.swiperIndex--
      }
      this.swiperInfo = this.imgList[this.swiperIndex]
      this.$refs.carousel.setActiveItem(this.swiperIndex)
    },
    nextSiwper() {
      if (this.swiperIndex == 3) {
        this.swiperIndex = 0
        console.log('in');
      } else {
        this.swiperIndex++
      }
      console.log(this.swiperIndex, 'add');
      this.swiperInfo = this.imgList[this.swiperIndex]
      this.$refs.carousel.setActiveItem(this.swiperIndex)


    },

    fullHeightChange() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          that.fullHeight = window.fullHeight
        })()
      }
    },
    gotop() {
      this.fullpage.current = 1
      this.directToMove(this.fullpage.current)
      // window.scrollTo({
      //   top: 0, //y 上线
      //   left: 0,//x 左右
      //   behavior: 'smooth',//属性值：默认值auto（相当于instant）、平滑滚动smooth、瞬间滚动instant
      // })
    }
  },
  mounted() {
    this.fullHeightChange()
    this.swiperInfo = this.imgList[0]
    this.nextImg = this.imgList[1].img
  },


};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "汉仪综艺体简";
  src: url(@/assets/font/HanYiZongYiTiJian-1.ttf);
}

.fullPage {
  height: 100vh;
  overflow: hidden;
}

.header1 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  height: 100px;
  transition: transform 1s;
}

.home {
  // transition: all linear 0.5s;
  transition: transform 1s;
  height: 100%;

  &-top {
    width: 100%;
    background: url(~@/assets/home/banner1.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  &-data {
    width: 100%;
    background: url(~@/assets/home/banner2.png);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

    &_header {
      // padding-top: 170px;
      text-align: center;
      padding-bottom: 150px;

      .p1 {
        font-size: 56px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #ffffff;
      }

      .p2 {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: bold;
        margin-top: 25px;
      }
    }

    &_bottom {
      width: 55%;
      display: flex;
      margin: auto;
      justify-content: space-between;
      align-items: center;

      .item {
        text-align: center;
        font-size: 17px;

        .description {
          margin: 44px 0 25px 0;
        }

        .num {
          font-size: 50px;
        }

        .img1 {
          width: 68px;
          height: 72px;
        }

        .img2 {
          width: 74px;
          height: 62px;
        }

        .img3 {
          width: 57px;
          height: 71px;
        }

        .img4 {
          width: 75px;
          height: 55px;
        }
      }
    }

    .statistics {
      text-align: center;
      // font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      margin-top: 200px;
    }
  }

  &-huochang {
    padding: 0 88px;
    display: flex;
    justify-content: center;
    align-items: center;

    &_left {
      text-align: center;
      padding-right: 59px;
      border-right: 1px solid #D2D2D2;

      h1 {
        font-size: 26px;
        margin-bottom: 30px;
        color: #333333;

      }

      .p1 {
        font-size: 19px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 30px;
      }

      .img {
        width: 602px;
        height: 371px;
      }
    }

    &_right {
      text-align: center;
      margin-left: 57px;

      .p1 {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #000000;
      }

      .p2 {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .nextImg {
        width: 357px;
        height: 201px;
      }

      .right_btn {
        img {
          width: 49px;
          height: 49px;
          cursor: pointer;

          &:first-child {
            margin-right: 25px;
          }
        }

        margin-bottom: 60px;
        margin-top: 90px;
      }
    }

  }

  &-pt {
    width: 100%;
    background: url(~@/assets/home/banner4.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    &_content {
      display: flex;
      align-items: center;
      height: 90%;
      padding: 0 68px;
      text-align: center;
    }

    h1 {
      font-size: 60px;
      font-family: '汉仪综艺体简';
      // font-weight: bold;
      color: #409EFF;
    }

    .p1 {
      font-size: 27px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #409EFF;
      margin-top: 33px;
    }

    .p2 {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }

    .input {
      margin: 70px 0;
    }

    :deep(.el-input) {
      width: 640px;

      .el-input__inner {
        height: 80px;
        text-align: center;
        font-size: 23px;

      }

      .el-input__icon {
        font-size: 23px;
      }

      .el-input__suffix {
        right: 20px;
      }
    }
  }

  &-shouji {
    display: flex;
    justify-content: center;
    align-items: center;

    .content {
      // height: 90%;
      // padding: 0 100px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // text-align: center;

      .contentImg {
        width: 1085px;
        height: 555px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .left {
        img {
          width: 605px;
          height: 653px;
        }
      }

      .right {
        h1 {
          font-size: 76px;
          font-family: '汉仪综艺体简';
          font-weight: 400;
          color: #409EFF;
        }

        .p1 {
          font-size: 27px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #409EFF;
          margin-bottom: 70px;
        }

        .p2 {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 20px;
        }
      }
    }
  }

  &-fw {
    display: flex;

    .content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 170px;
      text-align: center;
      box-sizing: content-box;
      width: 1090px;
      margin: auto;

      img {
        width: 100%;
        height: 100%;

        &:hover {
          transform: scale(120%);
          transition: transform .5s;
        }
      }

      .item {
        width: 530px;
        height: 280px;
        overflow: hidden;

      }

      .p1 {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #282828;
        margin-bottom: 5px;
      }

      .p2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }
    }
  }

  &-hb {
    display: flex;

    .content {
      width: 1090px;
      margin: auto;

      .map {
        padding: 0 105px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: content-box;
      }

      h1 {
        text-align: center;
        font-size: 50px;
        font-family: '汉仪综艺体简';
        font-weight: 400;
        color: #409EFF;
        margin-bottom: 100px;
      }

      .item {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.28);
        border-radius: 10px;
        margin-bottom: 45px;
        overflow: hidden;
        width: 180px;
        height: 70px;

        &:hover {
          transform: scale(120%);
          // transition: 0.1s ease-in-out;
          transition: transform .5s;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}


:deep(.el-menu--horizontal) {
  &:hover {
    .header1 {
      opacity: 1;
      background: #fff;
    }
  }
}
</style>